import React from 'react';
import { FundDetailSC } from './fund-detail.styled';
import { HeadingFour, SmallText } from '../../../typography';

function FundDetail({ label, title, className }) {
  return (
    <FundDetailSC className={className ? className : ''}>
      <HeadingFour className="white title bigger">{title}</HeadingFour>
      <SmallText className="dark-grey bigger">{label}</SmallText>
    </FundDetailSC>
  );
}

export default FundDetail;
